import _ from 'lodash'
import useIdToFindResourceList from '@/views/creative/utils/use-id-to-find-resource-list.js'
import generateId from '../../../utils/generateId.js'
import {
  GameDifficulty,
  GameDifficultyItem,
  GameConfigVersion,
  GameDifficultyCategoryId,
  GameConfigResource,
} from '@/types/dmaker/game-config.type'
import { I18nResource } from '@/types/dmaker/i18n.type'
import { Resource } from '@/types/dmaker/resource.type'
import { I18nLanguageItem } from '@/types/dmaker/i18n.type'
import {
  gameConfigCategoryResourceType,
  i18nCategoryResourceType,
} from '@/store/creative/common/category'

export function isV1GameDifficulty(gameConfig: GameDifficulty): boolean {
  return (
    !_.isEmpty(gameConfig) &&
    ['easy', 'medium', 'hard'].some(
      (key) => typeof gameConfig[key] !== 'undefined',
    )
  )
}

export function isV3GameDifficulty(gameConfig: GameDifficulty): boolean {
  // 如果 gameConfig 为空，则认为是 V3
  if (_.isEmpty(gameConfig)) return true
  for (const key in gameConfig) {
    // eslint-disable-next-line no-prototype-builtins
    if (gameConfig.hasOwnProperty(key)) {
      const conf = gameConfig[key]
      if (
        Object.prototype.toString.call(conf) === '[object Object]' &&
        conf &&
        typeof conf.type === 'string'
      ) {
        return true
      }
    }
  }
  return false
}

export function computeGameDifficulty(
  gameConfig: GameDifficulty,
): GameConfigVersion {
  if (isV1GameDifficulty(gameConfig)) {
    return 'v1'
  } else if (isV3GameDifficulty(gameConfig)) {
    return 'v3'
  }
  return 'v2'
}

export function findBasicResource({
  resource,
  categoryId,
}: {
  resource: {
    [key: number]: Resource
  }
  categoryId: number
}): Resource | null {
  const resourceList = useIdToFindResourceList({
    resource,
    id: categoryId,
  })
  if (resourceList && resourceList.length > 0) {
    return resourceList.find((item: Resource) => item.is_basic === 1) || null
  }
  return null
}

export function generateGameConfigResource({
  category_id,
  data,
  name,
  prefix,
}: {
  category_id: GameDifficultyCategoryId
  data: GameDifficultyItem
  name: string
  prefix: GameDifficultyCategoryId
}): GameConfigResource {
  return {
    id: generateId(),
    name,
    prefix,
    category_id,
    resource_type: gameConfigCategoryResourceType,
    data,
  }
}

export function generateI18nResource({
  category_id,
  data,
  name,
  name_en,
  prefix,
}: {
  category_id: number
  data: I18nLanguageItem
  name: string
  name_en: string
  prefix: string
}): I18nResource {
  return {
    id: generateId(),
    name,
    name_en,
    prefix,
    category_id,
    resource_type: i18nCategoryResourceType,
    data,
  }
}

/**
 * scene 场景、stage 环节、resource 资源、group 组
 */
export function isCommonI18n(data: {
  resource?: string
  stage?: string
  group?: string
  scene?: string
}): boolean {
  return (
    !data.resource &&
    !data.stage &&
    !data.group &&
    typeof data.scene === 'undefined'
  )
}
